import Public from '@model/public';
import User from '@model/user';
import Page from '@model/page';
import Overseas from '@model/overseas';

export default {
  Public,
  User,
  Page,
  Overseas
};